import Modal from "react-modal";

export const UpdatingModal = ({ actions, ctx, uiState }) => {
  
  const { onClose } = actions || {};

  const { 
    count, 
    label,
    numberOfItemsToUpdate = 0,
    numberOfItensToRemove = 0
  } = ctx || {};
  
  const { 
    isOpen,
    loadingAction = false,
    needMoreLines = false,
    numberOfAditionalLines = 0,
    isSettingsPage = false,
    isWarningModal = false 
  } = uiState || {};

  const shouldShowSpinner = !isWarningModal;

  const lines = ({ needMoreLines, numberOfAditionalLines }) => {
    if (isWarningModal && label.dynamicMessagesArr && label.dynamicMessagesArr.length > 1) {
      return label.dynamicMessagesArr.map((msg, idx) => ({
        firstPart: "",
        secondPart: msg,
        flag: `warning-${idx}`
      }));
    }

    if (!needMoreLines && !numberOfAditionalLines) {
      return [{
        firstPart: isWarningModal ? "" :  count,
        secondPart: count === 1 ? label.dynamicMessagesArr[0] : label.dynamicMessagesArr[1],
        flag: 'single'
      }]
    }

    const lines = [];
    if (numberOfItemsToUpdate > 0 && label.dynamicMessagesArr) {
      lines.push({
        firstPart: numberOfItemsToUpdate,
        secondPart: numberOfItemsToUpdate === 1 ? label.dynamicMessagesArr[0] : label.dynamicMessagesArr[1],
        flag: 'update',
      });
    };

    if (numberOfItensToRemove > 0 && label.dynamicMessagesArr) {
      lines.push({
        firstPart: numberOfItensToRemove,
        secondPart: numberOfItensToRemove === 1 ? label.dynamicMessagesArr[2] : label.dynamicMessagesArr[3],
        flag: 'remove',
      });
    }

    return lines;
  };

  if (isSettingsPage) {
    return (
      <Modal
        isOpen={loadingAction}
        onRequestClose={() => {}}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        style={{
          overlay: {
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 20000,
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            transform: "translate(-50%, -50%)",
            padding: "2rem",
            textAlign: "center",
            borderRadius: "8px",
          }
        }}
        contentLabel="Atualizando recomendação"
      >
        <div>
          {shouldShowSpinner && (
            <div className="spinner" style={{ marginBottom: "1rem" }}>
              <svg width="40" height="40" viewBox="0 0 40 40" stroke="#e75d0d">
                <circle
                  cx="20"
                  cy="20"
                  r="18"
                  fill="none"
                  strokeWidth="4"
                  strokeDasharray="90 150"
                  strokeLinecap="round"
                >
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    repeatCount="indefinite"
                    values="0 20 20;360 20 20"
                    dur="1s"
                  />
                </circle>
              </svg>
            </div>
          )}

          <p style={{ fontSize: "1rem", fontWeight: 500 }}>{label.primaryMessage}</p>
        </div>
      </Modal>
    );    
  }  

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={isWarningModal ? onClose : () => {}}
      shouldCloseOnOverlayClick={isWarningModal}
      shouldCloseOnEsc={isWarningModal}
      style={{
        overlay: {
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: 20000,
        },
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          transform: "translate(-50%, -50%)",
          padding: "2rem",
          textAlign: "center",
          borderRadius: "8px",
        }
      }}
      contentLabel="Atualizando recomendação"
    >
      <div>
        {shouldShowSpinner && (
          <div className="spinner" style={{ marginBottom: "1rem" }}>
            <svg width="40" height="40" viewBox="0 0 40 40" stroke="#e75d0d">
              <circle
                cx="20"
                cy="20"
                r="18"
                fill="none"
                strokeWidth="4"
                strokeDasharray="90 150"
                strokeLinecap="round"
              >
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  repeatCount="indefinite"
                  values="0 20 20;360 20 20"
                  dur="1s"
                />
              </circle>
            </svg>
          </div>
        )}

        <p style={{ fontSize: "1rem", fontWeight: 500 }}>{label.primaryMessage}</p>

        {lines({ needMoreLines, numberOfAditionalLines }).map((line, index) => (
          <p 
            key={line.flag}
            style={{ 
              marginTop: index === 0 ? "0.5rem" : "0.25rem", 
              color: "#5f5e5e",
              textAlign: line.secondPart.startsWith('•') ? 'left' : 'center'  // ✅ Alinha bullets à esquerda
            }}>
            {line.firstPart} {line.secondPart}
          </p>
        ))}

        {isWarningModal && (
          <button
            style={{
              marginTop: "1.5rem",
              padding: "0.5rem 1.25rem",
              borderRadius: "6px",
              border: "none",
              backgroundColor: "#e75d0d",
              color: "#fff",
              fontWeight: 500,
              cursor: "pointer"
            }}
            onClick={onClose}
          >
            {label.confirmButtonText ?? "Entendi"}
          </button>
        )}

      </div>
    </Modal>
  );
};